import React from 'react'
import {Container, Row, Col, Button} from 'react-bootstrap'
import {Link} from 'react-router-dom';
import "../styles/components/notfound.css";

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons'

export const NotFound = () => {
    return (
        <>
            <Container className ="notFound" fluid>
                <img  alt="" rel="preload" src = "/assets/images/backgroundUnderConstruction.jpg" className="imgnotFound"/>
                <Row >
                    <Col xs = {12} className= "text-center">
                        <Link to ="/"> <img src ='/assets/images/logo-fablab.png' alt='' width='280' className ="logoHome"/></Link>
                    </Col>
                </Row>
                <h2 className="notFoundText anim-typewriter-notFound">ERROR 404 - Página no encontrada</h2>   
                <Row className = "buttonNotfound h-100 " >
                    <Col xs = {12} className = "text-center" >
                        <Link to ="/conocenos">
                            <Button className = "fablab-button" size="lg" >
                            <FontAwesomeIcon icon={faHome} className ="iconContact" /> Cónoce más sobre nosotros 
                            </Button>
                        </Link>
                    </Col>
                </Row> 
            </Container>
        </>
    )
}
